import createIcon from '../../createIcon';

/**
 * @component @name RecordVoiceOver
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4wMDA5OCAxMy41QzExLjIxMDEgMTMuNSAxMy4wMDEgMTEuNzA5MSAxMy4wMDEgOS41QzEzLjAwMSA3LjI5MDg2IDExLjIxMDEgNS41IDkuMDAwOTggNS41QzYuNzkxODQgNS41IDUuMDAwOTggNy4yOTA4NiA1LjAwMDk4IDkuNUM1LjAwMDk4IDExLjcwOTEgNi43OTE4NCAxMy41IDkuMDAwOTggMTMuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05LjAwMDk4IDE1LjVDNi4zMzA5OCAxNS41IDEuMDAwOTggMTYuODQgMS4wMDA5OCAxOS41VjIxLjVIMTcuMDAxVjE5LjVDMTcuMDAxIDE2Ljg0IDExLjY3MSAxNS41IDkuMDAwOTggMTUuNVpNMTYuNzYxIDUuODZMMTUuMDgxIDcuNTVDMTUuOTIxIDguNzMgMTUuOTIxIDEwLjI2IDE1LjA4MSAxMS40NEwxNi43NjEgMTMuMTNDMTguNzgxIDExLjExIDE4Ljc4MSA4LjA2IDE2Ljc2MSA1Ljg2Wk0yMC4wNzEgMi41TDE4LjQ0MSA0LjEzQzIxLjIxMSA3LjE1IDIxLjIxMSAxMS42OSAxOC40NDEgMTQuODdMMjAuMDcxIDE2LjVDMjMuOTcxIDEyLjYxIDIzLjk4MSA2LjU1IDIwLjA3MSAyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RecordVoiceOver = createIcon('RecordVoiceOver', [
  [
    'path',
    {
      d: 'M9.00098 13.5C11.2101 13.5 13.001 11.7091 13.001 9.5C13.001 7.29086 11.2101 5.5 9.00098 5.5C6.79184 5.5 5.00098 7.29086 5.00098 9.5C5.00098 11.7091 6.79184 13.5 9.00098 13.5Z',
      key: '1y6hdc',
    },
  ],
  [
    'path',
    {
      d: 'M9.00098 15.5C6.33098 15.5 1.00098 16.84 1.00098 19.5V21.5H17.001V19.5C17.001 16.84 11.671 15.5 9.00098 15.5ZM16.761 5.86L15.081 7.55C15.921 8.73 15.921 10.26 15.081 11.44L16.761 13.13C18.781 11.11 18.781 8.06 16.761 5.86ZM20.071 2.5L18.441 4.13C21.211 7.15 21.211 11.69 18.441 14.87L20.071 16.5C23.971 12.61 23.981 6.55 20.071 2.5Z',
      key: '1369zo',
    },
  ],
]);

export default RecordVoiceOver;
